import { Skeleton } from "@mui/material";
import * as React from "react";

import styles from "./CommentCard.module.css";

/**
 * Renders 3 skeleton comments for loading state
 */
export function CommentsLoader() {
  return (
    <div style={{ maxWidth: "960px" }}>
      <CommentCardSkeleton />
      <CommentCardSkeleton />
      <CommentCardSkeleton />
    </div>
  );
}

/**
 * Skeleton loader for CommentCard that matches its structure
 */
export function CommentCardSkeleton() {
  // Randomize widths for more natural appearance
  const headerWidth = React.useMemo(
    () => ["35%", "40%", "45%"][Math.floor(Math.random() * 3)],
    [],
  );
  const line1Width = React.useMemo(
    () => ["90%", "92%", "95%"][Math.floor(Math.random() * 3)],
    [],
  );
  const line2Width = React.useMemo(
    () => ["85%", "88%", "92%"][Math.floor(Math.random() * 3)],
    [],
  );
  const line3Width = React.useMemo(
    () => ["55%", "60%", "65%"][Math.floor(Math.random() * 3)],
    [],
  );

  return (
    <div className={styles.card}>
      {/* Avatar skeleton */}
      <Skeleton
        variant="circular"
        width={32}
        height={32}
        className={styles.avatar}
        animation="wave"
      />

      {/* Content skeleton */}
      <div className={styles.content}>
        {/* Header skeleton (user name, timestamp, entity) */}
        <Skeleton
          variant="text"
          width={headerWidth}
          height={20}
          animation="wave"
          sx={{ marginBottom: "4px" }}
        />

        {/* Comment text skeleton - multiple lines */}
        <div className={styles.commentText}>
          <Skeleton
            variant="text"
            width={line1Width}
            height={16}
            animation="wave"
          />
          <Skeleton
            variant="text"
            width={line2Width}
            height={16}
            animation="wave"
          />
          <Skeleton
            variant="text"
            width={line3Width}
            height={16}
            animation="wave"
          />
        </div>
      </div>
    </div>
  );
}
